import React from 'react';
export function OpeningHook() {
  return <section className="bg-cream py-20 md:py-28 relative overflow-hidden" data-id="element-91">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-4xl relative z-10" data-id="element-92">
        {/* Decorative Leaf SVG */}
        <div className="flex justify-center mb-10 opacity-60" data-id="element-93">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="text-gold" data-id="element-94">
            <path d="M12 22C12 22 12 16 12 12C12 8 16 4 20 2C20 2 20 8 20 12C20 16 16 20 12 22Z" fill="currentColor" fillOpacity="0.5" data-id="element-95" />
            <path d="M12 22C12 22 12 16 12 12C12 8 8 4 4 2C4 2 4 8 4 12C4 16 8 20 12 22Z" fill="currentColor" data-id="element-96" />
          </svg>
        </div>

        <div className="text-center space-y-8" data-id="element-97">
          <p className="text-2xl md:text-3xl lg:text-4xl font-heading italic text-forest leading-relaxed" data-id="element-98">
            "¿Te ha pasado que despiertas sintiéndote ligera, pero apenas
            terminas de desayunar tu vientre se transforma en un globo tenso y
            doloroso?"
          </p>

          <div className="w-16 h-px bg-gold mx-auto my-8" data-id="element-99"></div>

          <div className="space-y-6 text-lg md:text-xl text-dark/80 font-body leading-relaxed max-w-3xl mx-auto" data-id="element-100">
            <p data-id="element-101">
              <strong className="text-forest font-bold" data-id="element-102">
                No es grasa. No es falta de ejercicio.
              </strong>{' '}
              Es una señal de auxilio de tu sistema digestivo que no puede más.
            </p>
            <p data-id="element-103">
              A las 11 PM, mientras buscas en Google{' '}
              <span className="italic" data-id="element-104">"cómo quitar los gases"</span> o{' '}
              <span className="italic" data-id="element-105">"por qué siempre estoy hinchada"</span>,
              la respuesta no está en un té mágico ni en una dieta de hambre.
            </p>
            <p className="text-xl md:text-2xl font-heading text-forest mt-8" data-id="element-106">
              La respuesta está en entender cómo nuestra comida tradicional está
              interactuando con tu cuerpo hoy.
            </p>
          </div>
        </div>
      </div>
    </section>;
}